import './styles/screen.less';
import 'console-polyfill';
import 'core-js/features/set';
import 'core-js/features/map';
import 'core-js/features/object';
import 'core-js/features/array/index';
import './utils/setupSentry';
import jQuery from 'jquery';

import './Logging.js';
import logo from './img/logo.png';
import Connection from './Connection';
import Slides from './Slides';
import Notifications from './Notifications';
import Statusbar from './Statusbar';
import Contest from './Contest';
import { getLogDump } from './Logging.js';
import { showToast, unbindToastEvents } from './Toasts';
import * as Sentry from '@sentry/browser';
import isSentryEnabled, { setSentryContext } from './utils/setupSentry';
import initializeSoundSource from './sounds/initializeSoundSource';
import canBrowserPlayAudio from './sounds/canBrowserPlayAudio';
import AudioStatusIndicator from './sounds/AudioStatusIndicator';
import setupScreenSaverDismiss from './utils/setupScreenSaverDismiss';
// set the CSRF token for all ajax requests
jQuery(document).ajaxSend(function(event, xhr, settings) {
	if (!(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url))) {
		xhr.setRequestHeader('X-CSRFToken', $('meta[name="csrf-token"]').attr('content'));
	}
});

window.Screen = {
	i18n: {  // texts for translations
		Back: 'Back',
		'Next slide': 'Next slide',
		Notifications: 'Notifications',
		'No recent events.': 'No recent events.',
		'Contest starting ...': 'Contest starting ...',
		'Contest prize': 'Contest prize',
		'Contest target': 'Contest target',
		Contestants: 'Contestants',
		target: 'target',
	},
	options: {
		container: document.getElementById('container'),
		screenId: null,
		screenHash: null,
		screenRotation: null,  // '90' or '-90'
		screenDeviceName: null,
		publicUrlToken: null,  // if set, it will be passed to all API requests to authenticate
		timezone: 'Europe/Copenhagen',
		locale: 'da_DK',
		platformUrl: 'https://platform.plecto.com/screen/',
		apiUrlPrefix: '/api/v2/screens/',
		apiUrlSuffix: '/next_slide/',
		apiUrlSuffixPrevious: '/prev_slide/',
		backUrl: '/',
		isDemo: false,  // use demo data?
		demoSlides: false,  // list of slide objects that will randomly cycle if screenId is not provided
		animationSpeed: 1000,  // slide animation speed
		loadDelay: 2000,  // how long to let the iframe load before sliding it in
		initialStatuses: [],
		i18n: {},
		sounds: [],
		audioStatusIndicatorEnabled: false,  // feature flag for audio status indicator toast
	},
	elements: {},  // DOM elements
	mode: 'slides',  // current mode of operation, 'slides' or 'contest'
	container: null,  // the main container $
	isLoading: false,  // is the screen making a manual load?

	init: function(options) {
		options = options ? options : {};
		this.options = $.extend(this.options, options);
		this.i18n = $.extend(this.i18n, this.options.i18n);
		this.container = $(this.options.container);

		if (!this.options.screenId && !this.options.demoSlides) {
			throw 'Please provide a screenId or demoSlides!';
		}
		setSentryContext(options.screenId);
		Screen.Notifications = Notifications;
		Connection.init();
		Screen.Connection = Connection;

		// throttle resize event
		let resizeTimeout = null;
		$(window).on('resize', function(e) {
			if (e.target === window) {
				if (!resizeTimeout) {
					resizeTimeout = setTimeout(function() {
						$(window).trigger('screenResized');
						resizeTimeout = null;
					// eslint-disable-next-line no-magic-numbers
					}, 200);
				}
			}
		});

		// check to see if the mouse is idle
		const that = this;
		const setMouseIdleTimeout = function() {
			clearTimeout(mouseIdleTimeout);
			return setTimeout(function() {
				that.container.addClass('mouse-idle');
			// eslint-disable-next-line no-magic-numbers
			}, 4000);
		};
		let mouseIdleTimeout = setMouseIdleTimeout();
		const pos = { x: 0, y: 0 };
		$(document).on('click.idler', function(e) {
			clearTimeout(mouseIdleTimeout);
			if (that.container.hasClass('mouse-idle')) {
				that.container.removeClass('mouse-idle');
			}
			mouseIdleTimeout = setMouseIdleTimeout();
		});
		$(document).on('mousemove.idler', function(e) {
			if (pos.x !== e.clientX || pos.y !== e.clientY) {
				pos.x = e.clientX;
				pos.y = e.clientY;
				clearTimeout(mouseIdleTimeout);
				if (that.container.hasClass('mouse-idle')) {
					that.container.removeClass('mouse-idle');
				}
			}
			mouseIdleTimeout = setMouseIdleTimeout();
		});

		// time ticker event
		this.tickInterval = setInterval(function() {
			$(window).trigger('timeTick');
		// eslint-disable-next-line no-magic-numbers
		}, 1000);

		// create the DOM
		this.renderDOM();

		if (!this.options.blocked) {
			// init starting mode
			this.changeMode(this.mode, true);
		} else {
			showToast(
				'Access to your organization has been blocked.',
				this.options.blockReason 
					? `The reason for blocking your account is as follows: ${this.options.blockReason}`
					: '', 'Reload',
				0,
				() => window.location.reload(true));
		}

		// init rotation
		this.resizeRotatedContainer();
		$(window).on('screenResized.screenRotation', function() {
			that.resizeRotatedContainer();
		});

		this.sounds = options.sounds;

		if (canBrowserPlayAudio()) {
			this.soundSource = initializeSoundSource(options.sounds);
			// Initialize audio status indicator to show when AudioContext is suspended
			// Only if feature flag is enabled
			if (options.audioStatusIndicatorEnabled) {
				AudioStatusIndicator.init();
			}
		}

		setupScreenSaverDismiss();
	},

	trans: function(str) {

		// use this to get the translated string
		if (this.i18n.hasOwnProperty(str)) {
			return this.i18n[ str ];
		} else {
			// eslint-disable-next-line no-undef
			log('TRANSLATIONS: Missing translation for: ' + str);
		}
		return str;
	},

	resizeRotatedContainer: function() {
		const transform = 'rotate(' + Screen.options.screenRotation + 'deg)';
		if (Screen.options.screenRotation === '90' || Screen.options.screenRotation === '-90') {
			const body = $('body');
			const adjust = (body.width() - body.height()) / 2;
			this.container.css({
				transform: transform,
				'-webkit-transform': transform,
				'-ms-transform': transform,
				height: body.width(),
				width: body.height(),  // opposite on purpose
				marginTop: 0 - adjust,
				marginLeft: adjust,
			});
		} else if (Screen.options.screenRotation === '180') {
			this.container.css({
				transform: transform,
				'-webkit-transform': transform,
				'-ms-transform': transform,
			});
		}
	},

	renderDOM: function() {
		const that = this;
		let content = '';
		content += '<div id="screen-container">';
		content += '	<div id="slides"></div>';
		content += '	<div id="header" class="header">';
		content += '		<div class="header-menu">';
		content += '			<p class="header-title">' + Screen.options.title + '</p>';
		// eslint-disable-next-line max-len
		content += '			<div class="header-button js-prev-slide"><span class="header-button-text">' + this.trans('Previous slide') + '</span></div>';
		// eslint-disable-next-line max-len
		content += '			<div class="header-button js-next-slide"><span class="header-button-text">' + this.trans('Next slide') + '</span></div>';
		content += '		</div>';
		// eslint-disable-next-line max-len
		content += '		<a href="' + Screen.options.backUrl + '" title="' + this.trans('Back') + '" class="header-logo">';
		content += '			<img src="' + logo + '" alt="Plecto" class="header-logo-img" />';
		content += '		</a>';
		content += '	</div>';
		content += '	<div id="statusbar">';
		content += '		<div class="statusbar-container">';
		content += '			<div class="statusbar-label" id="statusbar-time"></div>';
		content += '			<div class="statusbar-content">';
		// eslint-disable-next-line max-len
		content += '				<div class="statusbar-content-item statusbar-content-item-empty"><div class="statusbar-title">' + this.trans('No recent events.') + '</div></div>';
		content += '			</div>';
		content += '		</div>';
		content += '		<div class="statusbar-width-test"></div>';
		content += '		<div class="statusbar-width-author-test"></div>';
		content += '	</div>';
		content += '	<div id="notifications"></div>';
		content += '	<div id="contest"></div>';
		content += '</div>';
		content += '<div id="error" style="display:none;"></div>';
		this.container.html(content);
		this.elements.slides = this.container.find('#slides');
		this.elements.statusbar = this.container.find('#statusbar');
		this.elements.statusbarTime = this.container.find('#statusbar-time');
		this.elements.notifications = this.container.find('#notifications');
		this.elements.contest = this.container.find('#contest');
		this.elements.prevSlide = this.container.find('.js-prev-slide');
		this.elements.nextSlide = this.container.find('.js-next-slide');
		this.elements.error = this.container.find('#error');

		this.elements.nextSlide.on('click', function(e) {
			e.preventDefault();
			if (that.mode === 'slides') {
				Slides.manualNextSlide();
			}
		});

		this.elements.prevSlide.on('click', function(e) {
			e.preventDefault();
			if (that.mode === 'slides') {
				Slides.manualPrevSlide();
			}
		});

		this.hideSlideControls();
	},

	hideSlideControls: function() {
		this.elements.prevSlide.hide();
		this.elements.nextSlide.hide();
	},

	showSlideControls: function() {
		this.elements.prevSlide.show();
		this.elements.nextSlide.show();
	},

	changeMode: function(newMode, initial) {
		// eslint-disable-next-line no-undef
		log('changeMode', newMode);
		initial = initial ? initial : false;
		if (!initial && this.mode === newMode) {
			return;  // skip if no change
		}
		if (!initial) {

			// destroy classes that we are changing from
			if (this.mode === 'slides') {
				Slides.destroy();
				Notifications.destroy();
				Statusbar.destroy();
				AudioStatusIndicator.destroy();
			} else if (this.mode === 'contest') {
				Contest.destroy();
			}
		}

		// initialize classes we are changing to
		if (newMode === 'slides') {
			Slides.init(initial);
			Notifications.init();
			Statusbar.init();
			if (canBrowserPlayAudio() && this.options.audioStatusIndicatorEnabled) {
				AudioStatusIndicator.init();
			}
		} else if (newMode === 'contest') {
			Contest.init();
		}

		// save new mode
		this.mode = newMode;
	},

	showLoading: function() {
		this.isLoading = true;
		const loading = $('<div class="screen-loader"></div>');
		this.container.append(loading);
	},

	hideLoading: function() {
		this.isLoading = false;
		this.container.find('.screen-loader').remove();
	},

	throwError: function(e, countdownTime = 10) {
		function onAction() {
			window.location.reload(true);
		}
	
		showToast('Sorry, something went wrong.', e, 'Reload', countdownTime, onAction);

		throw Error(e);
	},

	logErrorToSentry: function(error, extras) {
		try {
			if (typeof Sentry !== 'undefined' && isSentryEnabled() && Sentry && Sentry.captureException) {
				Sentry.captureException(error, { extra: {
					...(extras || {}),
					windowLog: getLogDump(),
				}});
			}
		} catch (e) {
			// intentionally empty, we don't want to crash slideshow over this
		}
		
	},

	logMessageToSentry: function(message, extras) {
		try {
			if (typeof Sentry !== 'undefined' && isSentryEnabled() && Sentry && Sentry.captureMessage) {
				Sentry.captureMessage(message, { extra: {
					...(extras || {}),
					windowLog: getLogDump(),
				}});
			}
		} catch (e) {
			// intentionally empty, we don't want to crash slideshow over this
		}
		
	},

	hideError: function() {
		this.elements.error.html('');
		this.elements.error.hide();
		unbindToastEvents();
	},

	// called by plecto-dashboard
	reportDashboardLoaded: function(dashboardId) {
		Slides.onDashboardLoaded(dashboardId);
	}
};
